// MIT License - Copyright (c) 2026 Doug McNall - See .kiro/steering/general/development-standards.md for full license

/**
 * Discworld Universe - Aliens Configuration
 * 
 * IMPORTANT: This file only contains the planet-to-alien mapping.
 * All alien definitions are in src/config/AlienSpeciesConfig.js
 * 
 * Workflow:
 * 1. Add alien to AlienSpeciesConfig.js first
 * 2. Then map it to planets here
 */

export const DiscworldAliensPlanets = {
  // Planet-specific alien populations
  planets: {
    500: ['librarian', 'luggage', 'death'],  // DISCWORLD (main disc)
    501: ['librarian'],  // ROUNDWORLD (magical observers)
    502: ['dropbear', 'bunyip'],  // XXXX (dangerous Australian analog)
    503: ['djinn'],  // KLATCH (desert, djinn territory)
    504: ['werewolf'],  // FOURECKS MOON (werewolf territory)
    505: ['vampire'],  // LLAMEDOS (Welsh analog, vampires)
    506: ['vampire', 'igor', 'werewolf'],  // ÜBERWALD (Transylvania analog)
    507: ['luggage'],  // COUNTERWEIGHT CONTINENT (sapient pearwood origin)
    508: ['death'],  // KRULL (edge of disc, Death's domain nearby)
    509: ['thing'],  // DUNGEON DIMENSIONS (eldritch horrors)
    510: ['werewolf'],  // LANCRE (mountain kingdom, werewolves)
    511: ['vampire', 'werewolf'],  // RAMTOPS (mountain range, supernatural)
    512: ['librarian'],  // BAD ASS (Granny Weatherwax's home, magical)
    513: ['vampire', 'djinn'],  // GENUA (New Orleans analog, voodoo/magic)
    514: ['djinn'],  // EPHEBE (Greek analog, philosophy and djinn)
    515: ['djinn'],  // OMNIA (religious empire, djinn)
    516: ['djinn', 'death'],  // TSORT (ancient civilization, djinn)
    517: ['djinn', 'death'],  // DJELIBEYBI (Egyptian analog, pyramids)
    518: ['luggage'],  // HUNGHUNG (Agatean Empire, pearwood)
    519: ['luggage', 'vampire'],  // BES PELARGIC (major Agatean port)
    520: ['vampire'],  // QUIRM (French analog, sophisticated vampires)
    521: ['dragonlord'],  // WYRMBERG (dragon realm)
    522: ['werewolf', 'vampire'],   // SKUND FOREST (dark forest, supernatural)
    550: ['librarian', 'luggage'],  // UNSEEN UNIVERSITY OBSERVATORY
    551: ['death'],  // PATRICIAN'S ORBITAL PLATFORM
    552: ['igor'],  // IGOR'S SPARE PARTS DEPOT
    553: ['death'],  // DEATH'S DOMAIN OUTPOST
    554: ['dragonlord']  // COHEN'S BARBARIAN OUTPOST
  },

  // Random encounter aliens (during warp travel)
  randomEncounters: [
    'librarian',
    'luggage',
    'igor',
    'vampire',
    'werewolf',
    'djinn'
  ],

  // Hostile aliens
  hostileSpecies: [
    'dropbear',
    'thing'
  ],

  // Friendly traders
  friendlyTraders: [
    'librarian',
    'igor',
    'vampire',
    'djinn'
  ]
};

export default DiscworldAliensPlanets;
